export enum NdsTagSize {
  COMPACT = 'compact',
  DEFAULT = 'default',
  BIG = 'big',
}

export enum NdsTagColor {
  NEUTRAL = 'neutral',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
  DANGER = 'danger',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum NdsTagBorder {
  NONE = 'none',
  DASHED = 'dashed',
}
